import * as React from 'react';
import { List, Tooltip, Button } from 'antd';

import { IdValueNameObject } from 'common/models/defaultsModel';

import { Antd3Icon } from '../deprecated/antd3';

interface UploadedFilesListProps {
    items?: IdValueNameObject[];
    deleteItem(id: string | number): void;
    noData?: string;
}

export const UploadedFilesList: React.FunctionComponent<UploadedFilesListProps> = ({
    items,
    deleteItem,
    noData,
}) => (
    <List
        dataSource={items}
        renderItem={(item: IdValueNameObject) => (
            <List.Item
                actions={[
                    <Tooltip placement="left" title={`Delete ${item.name}`}>
                        <Button
                            size="small"
                            type="danger"
                            ghost
                            onClick={() => item.id && deleteItem(item.id)}
                        >
                            <Antd3Icon type="delete" />
                            Remove
                        </Button>
                    </Tooltip>,
                ]}
            >
                <List.Item.Meta title={item.name} />
            </List.Item>
        )}
        locale={{ emptyText: noData || 'No values added' }}
    />
);
